

export default {
  setFinishTraining(state, payload) {
    state.finish_training = payload
  },
  // 添加取消请求 {name, cancel_fn}
    setCancel(state, payload){
      // 如果是同一个请求， 则先取消前面的， 再添加
      const index = state.cancel.findIndex(item => item.name == payload.name)
      if(index !== -1){
        state.cancel[index].cancel_fn()
        state.cancel.splice(index,1)
      }
      state.cancel.push(payload)
    },
    // 设置当前播放视频的vod_id
    setPlayVodId(state, payload) {
      state.video.play_vod_id = payload
    },
    // 删除 取消请求池里的请求
    deleteCancel(state, name){
      let index = state.cancel.findIndex(item => item.name == name)
      if(index !== -1){
        state.cancel.splice(index,1)
      }
    },
    clearUserInfo(state) {
        state.user_info = {}
    },
    setUserInfo(state, payload) {
        state.user_info = payload
    },
    setCurrentEvent(state, payload) {
        state.current_event = payload
    },
    setLanguage(state, payload) {
        state.lang = payload
    },
    setUsername(state, username) {
        state.user_info.user_name = username
    },
    setUserEmail(state, email) {
        state.user_info.login_email = email
    },
    setUserPhone(state, phone) {
        state.user_info.login_phone = phone
    },
    setUserAvatar(state, avatar) {
        state.user_info.user_avatar = avatar
    },
    setPingInterval(state, payload) {
      let min = 4500;
      let max = 5500;
      let randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
      state.ping_interval = setInterval(() => {
          payload()
      }, randomNum)
    },
    setCurrentSessionStatus(state, payload) {
        state.current_session_status = (payload == "True")
    },
    setCurrentSessionId(state, payload) {
        state.current_session_id = payload
    },
    clearPingInterval(state) {
        clearInterval(state.ping_interval)
    },
    add_ajax_spin(state) {
        state.ajax_spin_count++
    },
    sub_ajax_spin(state) {
        state.ajax_spin_count--
    },
    reset_ajax_spin(state) {
        state.ajax_spin_count = 0
    },
    saveEventMutation(state, payload){
      state.event = payload
    },
    set_current_role(state,payload){
      state.current_role = payload
    },
  set_current_event_id(state,payload){
    state.current_event_id = payload
  },
  saveEventMutation(state, payload){
    state.event = payload
  },
  changeIsRegister(state, payload){
    state.isRegister = payload
  },
  setAssistantTempSession(state,payload){
    state.assistant_temp_session=payload
  },
  clearAssistantTempSession(state){
    state.assistant_temp_session = null
  },
  setHelperRoles(state, payload){
    state.helper_roles = payload
  },
  hvuex(state, v) {
    var strObj = JSON.stringify(state.data);
    var obj = Object.assign(JSON.parse(strObj), v);
    state.data = obj;
    // console.log(obj, "hvuexMutations")
    hsetStore("hvuex",JSON.stringify(state.data));
  },
  setChannelList(state, channel_list){
    state.channel_list = channel_list
  },
  set_place_map(state,payload) {
    state.place_map = payload
  },
  set_current_identify(state,payload){
      state.current_identify = payload
  },
  get_identify_list(state,payload) {
    state.user_identify = []
  },
  set_unread_count(state, payload){
    // {type: 消息类型, count: 未读数}
    state.unread[payload.type + '_count'] = payload.count
  },
  sub_unread_count(state, key){
    if(state.unread[key+'_count'] && state.unread[key+'_count'] > 0){
      state.unread[key+'_count']--
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js